//
// TriState.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var TriState = {
    FALSE_STATE:0,
    TRUE_STATE:1,
    AUTOMATIC:2
};
export default TriState;
